"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BufferModal = exports.BufferInput = exports.BufferMode = void 0;
const react_1 = __importStar(require("react"));
const gds_ux_components_1 = require("@granular/gds-ux-components");
const react_intl_1 = require("react-intl");
const util_1 = require("../../util");
var BufferMode;
(function (BufferMode) {
    BufferMode["FIELD"] = "field";
    BufferMode["ADD"] = "add";
    BufferMode["CUT"] = "cut";
})(BufferMode = exports.BufferMode || (exports.BufferMode = {}));
const BufferInput = ({ onChange }) => {
    const inputRef = react_1.default.useRef(null);
    (0, react_1.useEffect)(() => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    return (react_1.default.createElement("input", { ref: inputRef, type: "number", name: "buffersize", required: true, onChange: onChange, className: "gk-input form-control" }));
};
exports.BufferInput = BufferInput;
const BufferModal = ({ isOpen, onCancel, onCreate, uom, cuttingStripMode, }) => {
    const [bufferSize, setBufferSize] = react_1.default.useState();
    const handleChange = (event) => {
        setBufferSize(event.target.value ? parseInt(event.target.value) : undefined);
    };
    (0, react_1.useEffect)(() => {
        setBufferSize(undefined);
    }, [isOpen]);
    return (react_1.default.createElement(gds_ux_components_1.GKModal, { className: "w-80", isOpen: isOpen, size: "sm", "data-qa": "BufferModal__Modal" },
        react_1.default.createElement("form", null,
            react_1.default.createElement(gds_ux_components_1.GKModalHeader, { toggle: () => onCancel() },
                react_1.default.createElement(util_1.Conditional, { match: cuttingStripMode === BufferMode.FIELD },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "Field_boundary_buffer_label" })),
                react_1.default.createElement(util_1.Conditional, { match: cuttingStripMode === BufferMode.ADD },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "Add_cutting_strip_buffer_label" })),
                react_1.default.createElement(util_1.Conditional, { match: cuttingStripMode === BufferMode.CUT },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "Split_cutting_strip_buffer_label" }))),
            react_1.default.createElement(gds_ux_components_1.GKModalBody, null,
                react_1.default.createElement(gds_ux_components_1.Container, { className: "p-0", style: { maxWidth: "unset", overflowX: "hidden" } },
                    react_1.default.createElement(gds_ux_components_1.Row, null,
                        react_1.default.createElement(gds_ux_components_1.Col, { sm: 12, md: 12, lg: 12 },
                            react_1.default.createElement(gds_ux_components_1.GKLabel, null,
                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "Buffer_width_input_label" })))),
                    react_1.default.createElement(gds_ux_components_1.Row, null,
                        react_1.default.createElement(gds_ux_components_1.Col, { sm: 10, md: 10, lg: 10 },
                            react_1.default.createElement(gds_ux_components_1.GKInputGroup, null,
                                react_1.default.createElement(exports.BufferInput, { onChange: handleChange }),
                                react_1.default.createElement(gds_ux_components_1.GKInputGroupAddon, { addonType: "append" }, uom)))))),
            react_1.default.createElement(gds_ux_components_1.GKModalFooter, null,
                react_1.default.createElement(gds_ux_components_1.GKButton, { color: "link", onClick: () => onCancel(), "data-qa": "buffer-modal-cancel" },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "Cancel" })),
                react_1.default.createElement(gds_ux_components_1.GKButton, { type: "submit", color: "primary", onClick: () => onCreate(bufferSize, uom), disabled: !bufferSize, "data-qa": "buffer-modal-add-event" },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "Ok" }))))));
};
exports.BufferModal = BufferModal;
